import { App } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePlan } from './usePlan';
import { FeatureKey } from '../constants/features';

/**
 * ライトプラン限定機能のガード。
 * 無料プランで機能を使おうとしたとき、共通のアップグレード誘導ダイアログを表示する。
 * 使い方: `guard('folder_tag', () => openModal())` のように、実行したい処理を渡す。
 */
export function usePlanGuard() {
  const { modal } = App.useApp();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { canUse, planInfo } = usePlan();

  const showUpgradeModal = () => {
    // 無料トライアルは1事業所1回だけ。利用済みの事業所には「60日間無料」を出さない。
    const trialAvailable = planInfo?.trialAvailable === true;
    modal.confirm({
      title: t('plan.upgradeTitle'),
      content: trialAvailable
        ? t('plan.upgradeContent')
        : t('plan.upgradeContentNoTrial'),
      okText: t('plan.viewPlan'),
      cancelText: t('common.close'),
      onOk: () => navigate('/plan'),
    });
  };

  /** feature が使えれば action を実行、使えなければアップグレードダイアログを表示する。 */
  const guard = (featureKey: FeatureKey, action: () => void) => {
    if (canUse(featureKey)) {
      action();
    } else {
      showUpgradeModal();
    }
  };

  return { guard, showUpgradeModal, canUse };
}
